import { render, staticRenderFns } from "./dictionaryData.vue?vue&type=template&id=08bf41b4&scoped=true"
import script from "./dictionaryData.vue?vue&type=script&lang=js"
export * from "./dictionaryData.vue?vue&type=script&lang=js"
import style0 from "./dictionaryData.vue?vue&type=style&index=0&id=08bf41b4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf41b4",
  null
  
)

export default component.exports